<template>
  <div>
    <!-- <div class="tab" v-if="tabShow"> -->
    <div class="tab">
      <div class="tab_top">
        <div class="tab_top_title">
          <div class="flexCS tab_top_title_left">
            <div class="tab_top_title_icon"></div>
            <div>轨迹回放</div>
          </div>
        </div>
        <div class="flexCB" style="margin: 10px 0">
          <span style="color: #1aa689; font-size: 14px">IMEI</span>
          <el-input v-model="searchImei" size="mini"></el-input>
          <el-button type="success" size="mini" @click="searchImerHandle()"
            >查询</el-button
          >
        </div>
        <div class="tab_top_equipment">
          <div>设备号： {{ staffInfo.imei }}</div>
          <div>设备名称： {{ staffInfo.deviceName }}</div>
        </div>

        <el-date-picker
          size="mini"
          v-model="searchTime"
          @change="searchTimeChange"
          :default-value="dateDefaultShow"
          unlink-panels
          :clearable="true"
          :picker-options="expireTimeOption"
          value-format="yyyy-MM-dd HH:mm:ss"
          type="datetimerange"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker>
        <div style="height: 15px"></div>
        <el-checkbox-group v-model="locTypes">
          <el-checkbox label="0">卫星定位</el-checkbox>
          <el-checkbox label="1">基站定位</el-checkbox>
          <el-checkbox label="2">Wi-Fi定位</el-checkbox>
        </el-checkbox-group>
        <div class="tab_top_select">
          <el-select v-model="deviceType" placeholder="请选择">
            <el-option label="普通轨迹模式" value="1"></el-option>
            <el-option label="普通轨迹播放（所有轨迹）" value="2"></el-option>
            <el-option
              label="行程轨迹播放（按照行程查询轨迹）"
              value="3"
            ></el-option>
          </el-select>
        </div>
        <div class="tab_top_search" @click="searchInfo()">搜索</div>
      </div>
      <div class="flexCB tab_bot">
        <div class="flexCB" style="width: 80%">
          <span>慢</span>
          <div style="width: 75%">
            <el-slider
              v-model="mapSpeed"
              :max="5000"
              @change="mapSpeedChange()"
            ></el-slider>
          </div>
          <span>快</span>
        </div>
        <div class="flex">
          <i
            style="font-size: 16px"
            class="el-icon-video-play"
            v-if="videoState === 'start'"
            @click="Repeat()"
          ></i>
          <i
            style="font-size: 16px"
            class="el-icon-video-play"
            v-if="videoState === 'resume'"
            @click="Resume()"
          ></i>
          <i
            style="font-size: 16px"
            class="el-icon-video-pause"
            v-if="videoState === 'pause'"
            @click="Pause()"
          ></i>
          <i
            style="margin-left: 5px; font-size: 16px"
            class="el-icon-refresh"
            @click="Repeat()"
          ></i>
        </div>
      </div>
      <div class="tab_track">
        <div>
          定位类型：{{
            staffTrackData.locType == 0
              ? "卫星定位"
              : staffTrackData.locType == 1
              ? "基站定位"
              : "Wi-Fi定位"
          }}
        </div>
        <div>定位时间：{{ staffTrackData.gpsTime }}</div>
        <div>行驶速度：{{ staffTrackData.speed }}km</div>
      </div>
    </div>
    <div class="tables">
      <div class="tables_tab">
        <div class="flex tables_tab_title">
          <div
            :class="item.value == tabVal ? 'active' : ''"
            v-for="item in tabsInfo"
            :key="item.value"
            @click="checkedTabVal(item.value)"
          >
            {{ item.name }}
          </div>
        </div>
        <div class="tables_tab_content">
          <e-table
            :selection="tableCheckbox"
            :paginationData="ipagination"
            :tableHeadConfig="columns"
            :tableLoadData="tableData"
            @selectLine="selectLine"
            height="100"
          >
            <template #serial="slotData">
              <p>{{ slotData.data.row.serial }}</p>
            </template>
            <template #locType="slotData">
              <p>
                {{
                  slotData.data.row.locType == 0
                    ? "卫星定位"
                    : slotData.data.row.locType == 1
                    ? "基站定位"
                    : "Wi-Fi定位"
                }}
              </p>
            </template>
            <template #stopType="slotData">
              <p>
                {{ slotData.data.row.stopType == 0 ? "普通停留" : "" }}
              </p>
            </template>
            <template #position="slotData">
              <p>
                {{
                  slotData.data.row.longitude + "," + slotData.data.row.latitude
                }}
              </p>
            </template>
          </e-table>
        </div>
      </div>
    </div>
    <div id="container" class="map-container"></div>
  </div>
</template>

<script>
import AMapLoader from "@amap/amap-jsapi-loader";
window._AMapSecurityConfig = {
  securityJsCode: "8e9c248f99df3ed6ea243177e37306d1",
};
import eTable from "./component/tabel-track";

import { httpAction } from "@/api/manage";
let infoWindow = null;
var navg1 = null;
export default {
  name: "positioningTrack",
  props: {},
  components: { eTable },
  mixins: [],
  created() {
    this.getGps(this.$route.query.imei || "868755124111022");
  },
  mounted() {
    this.$store.commit("TAGS_VIEW_SHOW", false);
    this.dateDefaultShow = new Date();
    this.dateDefaultShow.setMonth(new Date().getMonth() - 1);
  },
  data() {
    return {
      searchTime: "",
      dateDefaultShow: "",
      expireTimeOption: {
        disabledDate(date) {
          return date.getTime() >= Date.now();
        },
      },
      queryParam: {
        startTime: "",
        endTime: "",
      },
      staffInfo: {},
      map: null,
      lineList: [],
      newLineList: [],
      locTypes: ["0"],
      mapSpeed: 500,
      videoState: "start",
      searchImei: "",
      tabsInfo: [
        {
          name: "行程信息",
          value: "1",
        },
        {
          name: "轨迹信息",
          value: "2",
        },
        {
          name: "告警记录",
          value: "3",
        },
        {
          name: "停留记录",
          value: "4",
        },
      ],
      tabVal: 2,
      tableData: [],
      routeTableData: [],
      trackTableData: [],
      stopTableData: [],
      alarmTableData: [],
      ipagination: {
        current: 1,
        pageSize: 10,
        total: 0,
      },
      columns: [
        {
          field: "serial",
          label: "序号",
          columnType: "slot",
          slotName: "serial",
        },
        {
          field: "locType",
          label: "定位类型",
          columnType: "slot",
          slotName: "locType",
        },
        {
          field: "longitude",
          label: "经纬度",
          columnType: "slot",
          slotName: "position",
          width: 180,
        },
        {
          field: "speed",
          label: "平均速度(km/h)",
          width: 180,
        },
        {
          field: "direction",
          label: "方向",
        },
        {
          field: "satellitesNum",
          label: "卫星数",
        },
        {
          field: "complementFlag",
          label: "补传标识",
        },
        {
          field: "gpsTime",
          label: "定位时间",
          width: 180,
        },
        {
          field: "gateTime",
          label: "网关时间",
          width: 180,
        },
      ],
      tableCheckbox: true,
      staffTrackData: {},
      deviceType: "1",
    };
  },
  methods: {
    checkedTabVal(val) {
      this.tabVal = val;
      if (val == 1) {
        this.tableCheckbox = false;
        this.tableData = this.routeTableData;
        this.ipagination.total = this.routeTableData.length;
        this.columns = [
          {
            field: "serial",
            label: "序号",
            columnType: "slot",
            slotName: "serial",
          },
          {
            field: "startTime",
            label: "开始时间",
            width: 180,
          },
          {
            field: "endTime",
            label: "结束时间",
            width: 180,
          },
          {
            field: "mileage",
            label: "总里程(km)",
          },
          {
            field: "totalDuration",
            label: "总用时",
          },
          {
            field: "averageSpeed",
            label: "平均速度(km/h)",
          },
          {
            field: "highestSpeed",
            label: "最高时速",
          },
          {
            field: "createTime",
            label: "创建时间",
          },
          {
            field: "startAddr",
            label: "开始地址",
          },
          {
            field: "endAddr",
            label: "结束地址",
          },
        ];
      }
      if (val == 2) {
        this.tableCheckbox = true;
        this.tableData = this.trackTableData;
        this.ipagination.total = this.trackTableData.length;
        this.columns = [
          {
            field: "serial",
            label: "序号",
            columnType: "slot",
            slotName: "serial",
          },
          {
            field: "locType",
            label: "定位类型",
            columnType: "slot",
            slotName: "locType",
          },
          {
            field: "longitude",
            label: "经纬度",
            columnType: "slot",
            slotName: "position",
            width: 180,
          },
          {
            field: "speed",
            label: "平均速度(km/h)",
          },
          {
            field: "direction",
            label: "方向",
          },
          {
            field: "satellitesNum",
            label: "卫星数",
          },
          {
            field: "complementFlag",
            label: "补传标识",
          },
          {
            field: "gpsTime",
            label: "定位时间",
            width: 180,
          },
          {
            field: "gateTime",
            label: "网关时间",
            width: 180,
          },
        ];
      }
      if (val == 3) {
        this.tableCheckbox = false;
        this.tableData = this.alarmTableData;
        this.ipagination.total = this.alarmTableData.length;
        this.columns = [
          {
            field: "serial",
            label: "序号",
            columnType: "slot",
            slotName: "serial",
          },
          {
            field: "alarmMsg",
            label: "警告类型",
          },
          {
            field: "alarmTime",
            label: "警告时间",
          },
          {
            field: "alarmAddr",
            label: "警告地址",
          },
        ];
      }
      if (val == 4) {
        this.tableCheckbox = false;
        this.tableData = this.stopTableData;
        this.ipagination.total = this.stopTableData.length;
        this.columns = [
          {
            field: "serial",
            label: "序号",
            columnType: "slot",
            slotName: "serial",
          },
          {
            field: "stopType",
            label: "停留类型",
            columnType: "slot",
            slotName: "stopType",
          },
          {
            field: "leadTime",
            label: "停留时长",
          },
          {
            field: "address",
            label: "停留地址",
          },
          {
            field: "longitude",
            label: "经纬度",
            columnType: "slot",
            slotName: "position",
            width: 180,
          },
          {
            field: "startTime",
            label: "开始时间",
            width: 180,
          },
          {
            field: "endTime",
            label: "结束时间",
            width: 180,
          },
        ];
      }
    },
    selectLine(data) {
      try {
        if (data) this.staffTrackData = data;
        const that = this;
        new AMap.convertFrom([data.longitude, data.latitude], "gps", function (
          info,
          result
        ) {
          if (result.info === "ok") {
            var lnglats = result.locations;
            infoWindow = new AMap.InfoWindow({
              anchor: "top-center",
              offset: new AMap.Pixel(0, 10),
              content:
                `<div style="width: 250px; background: #fff; font-size: 12px; font-weight: 400;">` +
                `<div style=" color: #1aa689; font-size: 14px; display: flex; justify-content: space-between; padding: 5px 8px; background-color: #fbfbfb;">设备信息</div>` +
                `<div style="padding: 10px 8px;">` +
                `<div>定位类型：${
                  data.locType == 0
                    ? "卫星定位"
                    : data.locType == 1
                    ? "基站定位"
                    : "Wi-Fi定位"
                }</div>` +
                `<div>定位时间：${data.gpsTime}</div>` +
                `<div>行驶速度：${data.speed}km</div>` +
                `</div>` +
                `</div>`,
            });
            infoWindow.open(that.map, [lnglats[0].lng, lnglats[0].lat]);
            that.map.setCenter([lnglats[0].lng, lnglats[0].lat]);
          }
        });
      } catch (error) {
        infoWindow.close();
      }
    },
    getGps(imei) {
      httpAction("/tq/getGps", { imei }, "post").then((res) => {
        if (res.code !== 200) return this.$message.warning(res.msg);
        this.staffInfo = res.data;
        if (!this.queryParam.startTime && !this.queryParam.endTime) {
          this.searchTime = [
            res.data.gpsTime.substr(0, 10),
            res.data.gpsTime.substr(0, 10),
          ];
          this.queryParam = {
            startTime: res.data.gpsTime.substr(0, 10) + " 00:00:00",
            endTime: res.data.gpsTime.substr(0, 10) + " 23:59:59",
          };
        }
        this.getGpsHis(imei, res.data.gpsTime.substr(0, 10));
        httpAction(
          "/tq/getTrackSegment",
          {
            imeis: imei,
            ...this.queryParam,
            childFlag: 1,
            locTypes: this.locTypes.join(","),
          },
          "post"
        ).then((routeRes) => {
          if (routeRes.code !== 200) return this.$message.warning(routeRes.msg);
          routeRes.data.forEach((item, index) => {
            (item.serial = index + 1),
              (item.totalDuration = this.leadTime(
                item.startTime,
                item.endTime
              ));
          });
          this.routeTableData = routeRes.data;
        });

        httpAction(
          "/tq/getAlarm",
          {
            imeis: imei,
            ...this.queryParam,
            childFlag: 1,
            locTypes: this.locTypes.join(","),
          },
          "post"
        ).then((alarmRes) => {
          if (alarmRes.code !== 200) return this.$message.warning(alarmRes.msg);
          alarmRes.data.forEach((item, index) => {
            (item.serial = index + 1),
              (item.totalDuration = this.leadTime(
                item.startTime,
                item.endTime
              ));
          });
          this.alarmTableData = alarmRes.data;
        });
      });
    },
    getGpsHis(imei, date) {
      let url = "";
      if (this.deviceType == 1 || this.deviceType == 3) url = "/tq/getGpsHis";
      if (this.deviceType == 2) url = "/tq/getOriginalGpsHis";
      httpAction(
        url,
        {
          imei,
          ...this.queryParam,
          locTypes: this.locTypes.join(","),
          pageSize: 10000,
        },
        "post"
      ).then((res) => {
        if (res.code !== 200) return this.$message.warning(res.msg);
        if (!res.data.length) return this.$message.warning("暂无轨迹信息");
        this.trackTableData = res.data.map((item, index) => {
          return { ...item, serial: index + 1 };
        });
        this.tableData = this.trackTableData;
        this.staffTrackData = this.trackTableData[0];
        this.ipagination.total = res.data.length;
        res.data.forEach((item) => {
          this.lineList.push([item.longitude, item.latitude]);
        });
        this.initMap(imei);
      });
    },
    getStopSegment(imei, date) {
      httpAction(
        "/tq/getStopSegment",
        {
          imeis: imei,
          ...this.queryParam,
          locTypes: this.locTypes.join(","),
          childFlag: 1,
        },
        "post"
      ).then((res) => {
        if (res.code !== 200) return this.$message.warning(res.msg);
        var that = this;
        this.stopTableData = res.data.map((item, index) => {
          return {
            ...item,
            serial: index + 1,
            leadTime: "停留" + this.leadTime(item.startTime, item.endTime),
          };
        });
        res.data.forEach((item) => {
          new AMap.convertFrom(
            [item.longitude, item.latitude],
            "gps",
            function (info, result) {
              if (result.info === "ok") {
                var markers = [];
                var lnglats = result.locations;
                var icon = new AMap.Icon({
                  size: new AMap.Size(25, 34),
                  image:
                    "https://waliminiapp.oss-cn-beijing.aliyuncs.com/manage/gps/pullUp.png",
                  imageSize: new AMap.Size(25, 24),
                  imageOffset: new AMap.Pixel(0, 0),
                });

                var marker = new AMap.Marker({
                  position: new AMap.LngLat(lnglats[0].lng, lnglats[0].lat),
                  icon,
                  offset: new AMap.Pixel(-13, -16),
                });
                marker.on("click", function () {
                  markers.forEach((item) => {
                    item.setzIndex(12);
                  });
                  marker.setzIndex(13);
                  var leadTime = that.leadTime(item.startTime, item.endTime);
                  infoWindow = new AMap.InfoWindow({
                    anchor: "top-center",
                    offset: new AMap.Pixel(0, 10),
                    content:
                      `<div style="width: 250px; background: #fff; font-size: 12px; font-weight: 400;">` +
                      `<div style=" color: #1aa689; font-size: 14px; display: flex; justify-content: space-between; padding: 5px 8px; background-color: #fbfbfb;">停留${leadTime}</div>` +
                      `<div style="padding: 10px 8px;">` +
                      `<div>开始时间：${item.startTime}</div>` +
                      `<div>结束时间：${item.endTime}</div>` +
                      `<div>地址：${item.address}</div>` +
                      `</div>` +
                      `</div>`,
                  });
                  infoWindow.open(that.map, [lnglats[0].lng, lnglats[0].lat]);
                });
                markers.push(marker);
                that.map.add(markers);
              }
            }
          );
        });
      });
    },
    leadTime(startTime, endTime) {
      var date1 = new Date(startTime);
      var date2 = new Date(endTime);
      var difference = date2.getTime() - date1.getTime();
      var hours = Math.floor(difference / (1000 * 60 * 60))
        ? Math.floor(difference / (1000 * 60 * 60)) + "时"
        : "";
      var minutes =
        Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60)) + "分";
      var seconds = Math.floor((difference % (1000 * 60)) / 1000) + "秒";
      return `${hours + minutes + seconds}`;
    },
    searchInfo() {
      this.lineList = [];
      this.getGps(this.$route.query.imei || "868755124111022");
    },
    searchImerHandle() {
      this.lineList = [];
      if (!this.searchImei)
        return this.$message.warning("请输入要查询的设备号");
      this.getGps(this.searchImei);
    },
    searchTimeChange(date) {
      if (date) {
        this.queryParam.startTime = date[0];
        this.queryParam.endTime = date[1];
      } else {
        this.queryParam.startTime = "";
        this.queryParam.endTime = "";
      }
    },
    initMap(imei) {
      AMapLoader.load({
        key: "c98add164435e1dd4beff2d292a4fffb",
        version: "2.0",
        plugins: [
          "AMap.ToolBar",
          "AMap.Scale",
          "AMap.HawkEye",
          "AMap.MapType",
          "AMap.Geolocation",
          "AMap.ControlBar",
          "AMap.Driving",
          "AMap.convertFrom",
        ],
        AMapUI: {
          version: "1.1",
          plugins: [],
        },
      })
        .then((AMap) => {
          this.map = new AMap.Map("container", {
            viewMode: "3D",
            //  pitch:45,
            terrain: true,
            zoom: 13.4,
          });
          this.getStopSegment(imei);
          let newLineList = [];
          for (let i = 0; i < this.lineList.length; i += 500) {
            let batch = this.lineList.slice(i, i + 500);
            newLineList.push(
              new Promise((resolve, reject) => {
                new AMap.convertFrom(batch, "gps", function (info, result) {
                  if (info === "complete" && result.info === "ok") {
                    var list = result.locations.map((item) => [
                      item.lng,
                      item.lat,
                    ]);
                    return resolve(list);
                  }
                });
              })
            );
          }
          Promise.all(newLineList).then((res) => {
            this.lineList = res.flatMap((subArray) => subArray);
            newLineList = [];
            var startIcon = new AMap.Icon({
              size: new AMap.Size(25, 34),
              image:
                "//a.amap.com/jsapi_demos/static/demo-center/icons/dir-marker.png",
              imageSize: new AMap.Size(135, 40),
              imageOffset: new AMap.Pixel(-9, -3),
            });
            var startMarker = new AMap.Marker({
              position: new AMap.LngLat(
                this.lineList[0][0],
                this.lineList[0][1]
              ),
              icon: startIcon,
              offset: new AMap.Pixel(-13, -22),
            });
            var endIcon = new AMap.Icon({
              size: new AMap.Size(25, 34),
              image:
                "//a.amap.com/jsapi_demos/static/demo-center/icons/dir-marker.png",
              imageSize: new AMap.Size(135, 40),
              imageOffset: new AMap.Pixel(-95, -3),
            });
            var endMarker = new AMap.Marker({
              position: new AMap.LngLat(
                this.lineList[this.lineList.length - 1][0],
                this.lineList[this.lineList.length - 1][1]
              ),
              icon: endIcon,
              offset: new AMap.Pixel(-13, -22),
            });
            this.map.add([startMarker, endMarker]);
            this.routeLine();
            this.map.addControl(new AMap.Scale());
            this.map.addControl(new AMap.MapType());
          });
        })
        .catch((e) => {
          console.log(e);
        });
    },
    routeLine() {
      AMapUI.load(["ui/misc/PathSimplifier", "lib/$"], (PathSimplifier, $) => {
        if (!PathSimplifier.supportCanvas) {
          alert("当前环境不支持 Canvas！");
          return;
        }

        var defaultRenderOptions = {
          renderAllPointsIfNumberBelow: -1,
          pathTolerance: 2,
          pathLineStyle: {
            lineWidth: 2,
            strokeStyle: "#f7b538",
            borderWidth: 2,
            borderStyle: "#f7b538",
            dirArrowStyle: false,
          },
          startPointStyle: {
            radius: 0,
            lineWidth: 0,
          },
          endPointStyle: {
            radius: 0,
            lineWidth: 0,
          },
          pathLineHoverStyle: {
            lineWidth: 2,
            strokeStyle: "#f7b538",
            borderWidth: 2,
            borderStyle: "#f7b538",
            dirArrowStyle: false,
          },
          pathLineSelectedStyle: {
            lineWidth: 2,
            strokeStyle: "#f7b538",
            borderWidth: 2,
            borderStyle: "#f7b538",
            dirArrowStyle: true,
          },
          dirArrowStyle: {
            stepSpace: 35,
            strokeStyle: "red",
            lineWidth: 5,
          },
          pathNavigatorStyle: {
            initRotateDegree: 0,
            width: 26,
            height: 26,
            autoRotate: false,
            lineJoin: "round",
            content: PathSimplifier.Render.Canvas.getImageContent(
              "https://waliminiapp.oss-cn-beijing.aliyuncs.com/manage/gps/staff.png"
            ),
            fillStyle: "#087EC4",
            strokeStyle: "#116394",
            lineWidth: 1,
            pathLinePassedStyle: {
              lineWidth: 2,
              strokeStyle: "#1aa689",
              borderWidth: 2,
              borderStyle: "#1aa689",
              dirArrowStyle: true,
            },
          },
        };

        var pathSimplifierIns = new PathSimplifier({
          zIndex: 100,
          map: this.map,

          getPath: function (pathData, pathIndex) {
            return pathData.path;
          },
          getHoverTitle: function (pathData, pathIndex, pointIndex) {
            if (pointIndex >= 0) {
              // return (
              //   pathData.name +
              //   "，点：" +
              //   pointIndex +
              //   "/" +
              //   pathData.path.length
              // );
              return null;
            }

            // return pathData.name + "，点数量" + pathData.path.length;
            return null;
          },
          renderOptions: defaultRenderOptions,
        });

        window.pathSimplifierIns = pathSimplifierIns;
        pathSimplifierIns.setData([
          {
            name: "路线0",
            path: this.lineList,
          },
        ]);
        navg1 = pathSimplifierIns.createPathNavigator(0, {
          speed: this.mapSpeed,
        });
        // navg1.start();
      });
      setTimeout(() => {
        this.map.setCenter([this.lineList[0][0], this.lineList[0][1]]);
      }, 500);
    },
    Repeat() {
      if (window.pathSimplifierIns) {
        pathSimplifierIns.setData([
          {
            name: "路线0",
            path: this.lineList,
          },
        ]);
      }
      navg1 = pathSimplifierIns.createPathNavigator(0, {
        speed: this.mapSpeed,
      });
      navg1.start();
      this.videoState = "pause";
    },
    Pause() {
      navg1.pause();
      console.log("pause");
      this.videoState = "resume";
    },
    Resume() {
      navg1.resume();
      console.log("resume");
      this.videoState = "pause";
    },
    mapSpeedChange() {
      navg1.setSpeed(this.mapSpeed);
    },
  },
  computed: {},
  watch: {},
  destroyed() {
    this.$store.commit("TAGS_VIEW_SHOW", true);
    this.map.destroy();
    this.map = null;
    navg1.destroy();
    navg1 = null;
  },
};
</script>

<style scoped lang="less">
.flex {
  display: flex;
}
.flexCB {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.flexCS {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.flexWCA {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-around;
}
.tab {
  width: 250px;
  height: 100vh;
  background: #fff;
  padding: 15px 10px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;

  .tab_top {
    .tab_top_title {
      font-size: 12px;
      font-weight: 600;

      .tab_top_title_icon {
        background: #1aa689;
        width: 5px;
        height: 15px;
        margin-right: 10px;
        border-radius: 5px;
      }
    }
    .tab_top_equipment {
      font-size: 12px;
      color: rgba(0, 0, 0, 0.85);
      div {
        margin: 16px 0;
      }
    }
    .tab_top_search {
      height: 24px;
      width: 100%;
      color: #fff;
      font-size: 12px;
      text-align: center;
      line-height: 24px;
      background: #1aa689;
      margin-top: 15px;
    }
    .tab_top_search:hover {
      opacity: 0.8;
      cursor: pointer;
    }
    .tab_top_select {
      margin-top: 15px;
      /deep/.el-input__inner {
        width: 230px;
        height: 28px;
      }
    }
    /deep/.el-date-editor {
      width: 230px;
    }
  }

  .tab_bot {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.85);
    border: 1px solid #e6e6e6;
    padding: 5px;
    margin: 10px 0 20px;
  }

  .tab_track {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.85);

    div {
      margin: 10px 0;
    }
  }
}

.tables {
  width: calc(100% - 250px);
  height: 260px;
  background: #fff;
  z-index: 1;
  position: absolute;
  right: 0;
  bottom: 0;

  .tables_tab {
    .tables_tab_title {
      div {
        // width: 82px;
        height: 35px;
        text-align: center;
        line-height: 30px;
        background: #fafafa;
        padding: 6px 16px;
        margin-right: 5px;
      }
      div:hover {
        color: #4ab99f;
        cursor: pointer;
      }
      .active {
        color: #1aa689;
      }
    }
  }
  /deep/th .el-checkbox:nth-of-type(1) {
    display: none;
  }
}

.map-container {
  width: 100vw;
  height: 100vh;
  // margin-top: 20px;
}
/deep/.amap-marker-label {
  border: none;
}
/deep/.el-button--mini {
  background: #1aa689;
  border: #1aa689;
  margin: 0 5px;
}
</style>
